import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class DevicesService extends EntityService {
  static get entity() {
    return 'devices';
  }

  static async getTypes(params = {}) {
    try {
      const response = await this.request().get(`${this.entity}/types-device`, {
        params
      });

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getStates() {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/states`
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFilteredTypes(params = {}) {
    try {
      const response = await this.request().get(`${this.entity}/filters/type`, {
        params
      });

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFilteredFirstNames(params = {}) {
    try {
      const response = await this.request().get(
        `${this.entity}/filters/first-name`,
        { params }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFilteredLastNames(params = {}) {
    try {
      const response = await this.request().get(
        `${this.entity}/filters/last-name`,
        { params }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFilteredPhones(params = {}) {
    try {
      const response = await this.request().get(
        `${this.entity}/filters/phone`,
        { params }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFilteredSerialNumbers(params = {}) {
    try {
      const response = await this.request().get(
        `${this.entity}/filters/serial-number`,
        { params }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFilteredDeviceCodes(params = {}) {
    try {
      const response = await this.request().get(
        `${this.entity}/filters/device-code`,
        { params }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFilteredList(params = {}) {
    try {
      const response = await this.request().get(`${this.entity}/filters/list`, {
        params
      });

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async attach(data = {}) {
    try {
      const response = await this.request().post(`${this.entity}/attach`, data);
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
